import { render, staticRenderFns } from "./cabinItem.vue?vue&type=template&id=2d0374b8&scoped=true&"
import script from "./cabinItem.vue?vue&type=script&lang=js&"
export * from "./cabinItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0374b8",
  null
  
)

export default component.exports